export default "__VITE_ASSET__C_86jrlF__"